<script setup lang="ts">
const platformStore = usePlatformStore();
const platformConfiguration = computed(
  () => platformStore.getPlatformConfiguration,
);

const { isLayoutDisabled, platformStyles } = useLayout();

const isMatchWornShirt = computed(() => platformStore.isMatchWornShirt);

usePrivateUpdates();
useAutomaticFollow();
useOneTap();
</script>

<template>
  <div
    class="base"
    :class="isMatchWornShirt ? 'mws' : 'whitelabel'"
    :style="platformStyles"
  >
    <div class="min-h-screen flex flex-col">
      <NuxtLoadingIndicator
        v-if="!isLayoutDisabled"
        color="var(--color-1)"
      />

      <LazyIdleLayoutHeaderContainer
        v-if="!isLayoutDisabled"
        :hydrate-on-idle="true"
      />

      <div class="flex-1">
        <slot class="grid grid-cols-12" />
      </div>

      <LazyVisibleLayoutFooter
        v-if="!isLayoutDisabled"
        :footer="platformConfiguration.footer"
        :hydrate-on-visible="true"
      />
    </div>

    <UserOnboardingDialog v-if="!isLayoutDisabled" />
  </div>
</template>
